module.exports = __webpack_public_path__ + "img/UTFREM-18.0d04ed28.jpg";